export enum HeaderType {
  LOGIN = 'LOGIN',
  DASHBOARD = 'DASHBOARD',
}

export const PARTNER_BASE = 'partner';

export const ROUTE_PARTNER = {
  SIGNUP: 'signup',
  DASHBOARD: 'dashboard',
  PARTNER: 'partner',
  FAQ: 'faq',
  DASHBOARD_NEW: 'dashboard_new',
  LEADS: 'leads',
  ACTIVE_CUSTOMER: 'customer',
  REFERRED_PARTNER: 'referredpartner',
  COLLATERAL: 'collateral',
  DEMO_VIDEOS: 'demo_videos',
  MY_ACCOUNT: 'my_account',
  CHECK_LIMIT: 'free-eligibility-check',
  AFFILIATE_SIGNUP: 'affiliate_signup',
  EARNING: 'earning',
  AUTH: 'auth',
  VIEW_CUSTOMER_PORTFOLIO: 'view-customer-portfolio',
  CAPITAL_GAIN: 'capitalGain',
  INTEREST_CALCULATOR: 'interest-calculator'
};
